module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "list_demo"
    }
  }, [_c('highlight')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e824e840!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListDemo.vue
// module id = 168
// module chunks = 1